import React from "react";
import { useTranslation } from "react-i18next";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

const JobCardSkeleton = ({ count = 3, className = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`row ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label={t("Common.LoadingJobs")}
    >
      <span className="skeleton-screen-reader-only">{t("Common.LoadingJobs")}</span>
      {Array.from({ length: count }, (_, index) => (
        <div className="mt-3 col-md-4 skeleton-job-row" key={`job-skeleton-${index}`}>
          <div className="shimmer-cont skeleton-surface p-3 h-100">
            <ShimmerTitle line={2} gap={8} />
            <ShimmerDiv className="mt-2" height={16} width="70%" rounded={4} />
            <ShimmerDiv className="mt-3" height={120} width="100%" rounded={8} />
            <div className="d-flex gap-2 mt-3">
              <ShimmerDiv height={36} width={100} rounded={6} />
              <ShimmerDiv height={36} width={100} rounded={6} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default JobCardSkeleton;
